import {FC} from 'react';
import {
	PARTNER_AGREEMENT_PENDING_DESCRIPTION,
	PARTNER_AGREEMENT_PENDING_TITLE,
} from '../../model';
import {FnsPendingEnvelopeIcon} from 'shared/assets/icons';
import {StepLayout} from 'features/registration';
import styles from './MyTaxFnsPendingStep.module.css';

export const PartnerAgreementPendingStep: FC = () => {
	return (
		<StepLayout variant="fill">
			<StepLayout.Intro
				title={PARTNER_AGREEMENT_PENDING_TITLE}
				subtitle={PARTNER_AGREEMENT_PENDING_DESCRIPTION}
			/>

			<StepLayout.Content className={styles.illustration}>
				<FnsPendingEnvelopeIcon className={styles.illustrationIcon} />
			</StepLayout.Content>
		</StepLayout>
	);
};
